export default __webpack_public_path__ + "static/media/logo-icon.c2392e9b.png";